import { _formatCourses } from '../../helpers'

const categories = state => state.categories
const currentCategory = state => state.currentCategory
const currentCategoryNewCourses = state =>
  _formatCourses(state.currentCategoryNewCourses)
const currentCategoryPopularCourses = state =>
  _formatCourses(state.currentCategoryPopularCourses)
const currentCategoryLearningPaths = state => state.currentCategoryLearningPaths

export default {
  categories,
  currentCategory,
  currentCategoryNewCourses,
  currentCategoryPopularCourses,
  currentCategoryLearningPaths,
}
